/**
 * Calcula o dígito verificador de um CNPJ alfanumérico (RFB 2026)
 * @param {string[]} chars Array de caracteres do CNPJ
 * @param {number} size Quantidade de posições a considerar
 * @returns {number}
 */
const calculateDigit = (chars, size) => {
  let weight = 2;
  let sum = 0;

  for (let i = size - 1; i >= 0; i--) {
    sum += (chars[i].charCodeAt(0) - 48) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }

  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

/**
 * Verifica se o CNPJ tem formato e dígitos verificadores válidos.
 * Suporta CNPJ alfanumérico (RFB 2026) e numérico legado.
 * @param {bool} required Se é obrigatório ou não
 * @param {string} cnpj CNPJ do cliente (com ou sem máscara)
 * @return {bool}
 */
export const isCnpjFormatValid = (required) => (cnpj) => {
  if (cnpj.length === 0 && !required) {
    return true;
  }

  if (!cnpj) {
    return false;
  }

  const sanitized = cnpj.replace(/[^A-Z0-9]/gi, "").toUpperCase();

  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(sanitized)) {
    return false;
  }

  const chars = sanitized.split("");

  if (new Set(chars).size === 1) {
    return false;
  }

  const firstDigit = calculateDigit(chars, 12);
  if (firstDigit !== parseInt(chars[12], 10)) {
    return false;
  }

  const secondDigit = calculateDigit(chars, 13);
  return secondDigit === parseInt(chars[13], 10);
};

export default isCnpjFormatValid;
